/**
 * 路線色の扱い。
 *
 * routes.color は明るいものも暗いものもある（島内 #7CB342 から
 * 天神 #3949AB まで）。**そのまま文字色に使ってはいけない。**
 * 白地に博多 #FB8C00 を載せるとコントラスト比が 2.3 程度しかなく、
 * 小さい字ではまず読めない。色で塗って文字色を切り替えるほうが確実。
 */

// 白文字を載せても読める濃さかどうか
export function isDarkColor(hex) {
  if (!hex || !/^#[0-9a-f]{6}$/i.test(hex)) return true;
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
  return (r * 299 + g * 587 + b * 114) / 1000 < 150;
}

// 路線色で塗ったチップの style。色が無い路線は灰に落とす
export function routeChipStyle(color) {
  const background = color || "#6b7280";
  return { background, color: isDarkColor(background) ? "#fff" : "#111827" };
}

/**
 * 乗番に添える路線チップ。**最大2つまで。**
 *
 * 3路線以上を並べても潰れて読めず、色が多すぎて手がかりにならない。
 * そこはまとめて「3路線以上」にする。まとめた印に色は付けない。
 * どれか1色を選ぶと、その路線が主だと誤解される。
 *
 * 乗番一覧と履歴カレンダーの両方で使う。**規則をここ1箇所に置くこと。**
 * 片方だけ 3 つ出るような食い違いが起きると、同じ乗番が画面によって
 * 違う顔に見える。
 *
 * @param {Array} routes 便数の多い順に並んだ路線
 */
export function routeChips(routes) {
  const list = routes ?? [];

  if (list.length >= 3) {
    return [{ key: "many", label: "3路線以上", many: true }];
  }

  return list.map((r) => ({
    key: r.route_id,
    label: r.route,
    style: routeChipStyle(r.color),
  }));
}
